
























































































import { Component, Vue, Watch } from "vue-property-decorator";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import GenericAdd from "@/core/Generics/GenericAdd";
import Area from "@/models/coding/areaModel";
import IndicatorType from '../../../models/indicator/indicatorType.model';
@Component
export default class IndicatorTypeAdd extends GenericAdd<IndicatorType> {
  constructor() {

    super();
     this.controller = 'IndicatorTypes';
    this.model = new IndicatorType();
  }
    saveAll(){
      this.model.indicatorGroupId = this.$route.params.indicatorGroupId as any;
      return this.validate();
  }
  
  cancel(){ this.$router.push(`${this.$router.currentRoute.path.split('/agregar')[0]}`)}

}
